import { px2rem } from '../utils/helpers/style.js';

var fileUploadThemeWeb = {
  backgroundSecondary: 'background.secondary',
  width: px2rem(362),
  height: px2rem(152),
  borderColor: 'border.inactive',
  inactiveText: 'text.disabled',
  focus: {
    background: 'background.secondary',
    outlineColor: 'primary'
  },
  listItem: {
    background: 'background.secondary'
  }
};

export { fileUploadThemeWeb };
